define('evicommon/search/search.service.filter',['require','exports','module','backbone'],function(require, exports, module) {
  var Backbone = require('backbone');

  var SearchServiceFilter = Backbone.Model.extend({
    isSearchServiceFilter: true,

    defaults: {
      query: '',
      queryFields: [],
      additionalSearchServiceParams: {},
    },
  });

  module.exports = SearchServiceFilter;
});

